<script>
import { ref } from '@vue/composition-api'
import { useMessage } from '@/hooks/useMessage'
import { publishAnnouncement, updateAnnouncement } from '@/views/announcement/service'
import { debounce } from '@prettyy/utils'

export default {
  name: 'PreviewRelease',
  props: {
    rowItem: {
      type: Object,
      default: () => ({}),
    },
  },

  setup(props, { emit }) {
    const visible = ref(true)
    const { message } = useMessage()
    const loading = ref(false)

    const submit = debounce(500, () => {
      loading.value = true
      const request = props.rowItem.messageId ? updateAnnouncement : publishAnnouncement
      request(props.rowItem).then(({ data }) => {
        if (data.status === 200 && data.data) {
          message.success(props.rowItem.messageId ? '编辑成功' : '发布成功')
          emit('onSuccess')
          visible.value = false
        } else {
          message.error(data.message || (props.rowItem.messageId ? '编辑失败' : '发布失败'))
        }
        loading.value = false
      }).catch(error => {
        message.error(error.response.data.message)
        loading.value = false
      })
    })

    function goBack() {
      visible.value = false
      emit('goBack')
    }

    return {
      visible,
      submit,
      goBack,
      loading,
    }
  },
}
</script>

<template>
  <vl-dialog
    v-loading="loading"
    :title="rowItem.title"
    :visible.sync="visible"
    width="800px"
    top="0"
    @close="$emit('close')"
  >
    <div class="PreviewView ql-container">
      <div class="ql-editor" style="white-space: pre-wrap;" v-html="rowItem.content" />
    </div>
    <template #footer>
      <div class="flex-right gap8">
        <v-btn
          outlined
          @click="goBack"
        >
          上一步
        </v-btn>
        <v-btn
          :loading="loading"
          color="primary"
          @click="submit"
        >
          确认发布
        </v-btn>
      </div>
    </template>
  </vl-dialog>
</template>

<style scoped lang="scss">
::v-deep .vl-dialog__title {
  text-align: center;
  flex: auto;
}

.PreviewView {
  max-height: 500px;
  min-height: 280px;
  overflow: auto;
  white-space: pre-wrap;
}
.ql-editor {
  width: 735px;
  ::v-deep img {
    width: auto;      /* 当图片较小的时候保持原始大小 */
    max-width: 100%;  /* 当图片较大时限制最大宽度为容器宽度 */
    height: auto;
    object-fit: cover;
  }
}

::v-deep .vl-dialog__body {
  padding: 20px 0;
}
</style>
